import React from "react";
import "./PageBanner.scss";

const PageBanner = ({ title, bgImage }) => {
  // style içine arkaplan görselini dinamik olarak ekliyoruz
  const bannerStyle = {
    backgroundImage: `url(${bgImage})`,
  };

  return (
    <div className="page-banner" style={bannerStyle}>
      <div className="page-banner__overlay"></div>
      <h1 className="page-banner__title">{title}</h1>
    </div>
  );
};

export default PageBanner;
